import { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import DeleteModal from "../../../common/DeleteModal";
import { useSelector } from "react-redux";
import editIcon from "../../../../images/icons/edit.svg";
import trashIcon from "../../../../images/icons/delete.svg";

const CardItem = ({ item, index, setShouldUpdate, Service }) => {
	const [deleteModal, setDeleteModal] = useState(false);
	const navigate = useNavigate();
	const location = useLocation();
	const lang = useSelector((state) => state.auth?.lang);
	const pathname = location?.pathname?.split("/")[1];

	return (
		<tr key={index}>
			<td className="text-wrap-mode">
				<p
					dangerouslySetInnerHTML={{
						__html: item[`title_${lang}`],
					}}></p>
			</td>
			<td>
				<a href={item?.image} target="_blank" rel="noreferrer">
					<img src={item?.image} alt="project" width={70} />
				</a>
			</td>
			{pathname === "projects" && (
				<td>
					{item?.link?.includes("http") ? (
						<a href={item?.link} target="_blank" rel="noreferrer">
							{item?.link}
						</a>
					) : (
						item?.link
					)}
				</td>
			)}
			<td>
				<div className="d-flex" style={{ gap: "20px" }}>
					<img
						src={editIcon}
						onClick={() => {
							pathname === "media-center"
								? navigate("/media-center/add-media", { state: item })
								: navigate("/projects/add-project", { state: item });
						}}
						className="cursor-pointer"
						alt="edit"
						width={24}
					/>
					<img
						src={trashIcon}
						onClick={() => setDeleteModal(true)}
						className="cursor-pointer"
						alt="trash"
						width={24}
					/>
				</div>
			</td>
			{deleteModal && (
				<DeleteModal
					open={deleteModal}
					titleMsg=""
					deletedItem={item}
					modelService={Service}
					setShouldUpdate={setShouldUpdate}
					onCloseModal={setDeleteModal}
				/>
			)}
		</tr>
	);
};
export default CardItem;
